// Full-site maintenance mode (hard block).
//
// When window.MAINTENANCE_MODE is true, the storefront is replaced with a full-screen
// maintenance page — browsing and checkout are blocked. window.MAINTENANCE_MESSAGE
// overrides the default copy shown on that page.
export function isMaintenanceMode() {
  if (typeof window === 'undefined') return false
  return window.MAINTENANCE_MODE === true || window.MAINTENANCE_MODE === 'true'
}

const DEFAULT_MESSAGE =
  "We're currently performing scheduled maintenance. Please check back shortly."

export function maintenanceMessage() {
  const m = typeof window !== 'undefined' ? window.MAINTENANCE_MESSAGE : undefined
  return typeof m === 'string' && m.trim().length > 0 ? m : DEFAULT_MESSAGE
}
